import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import 'typeface-roboto';
import '@mantine/core/styles.css';
import '@mantine/code-highlight/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-datatable/styles.css';
import './styles/global.css';

import './analytics/sentry';
import './api/config';

import React, {StrictMode, Suspense} from 'react';
import {RouterProvider} from 'react-router-dom';
import {AuthProvider} from './auth/use-auth';
import {createRoot} from 'react-dom/client';
import {AppRouter} from './routes/app-router';
import {MantineProvider} from '@mantine/core';
import {Notifications} from '@mantine/notifications';
import {DefaultTheme} from './styles/default-theme';
import {ModalsProvider} from '@mantine/modals';
import {NotificationService} from './utils/notification-service.ts';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Suspense fallback={null}>
    <MantineProvider theme={DefaultTheme}>
      <ModalsProvider>
        <Notifications position="top-right" />
        <NotificationService />
        <AuthProvider>
          <StrictMode>
            <RouterProvider router={AppRouter} />
          </StrictMode>
        </AuthProvider>
      </ModalsProvider>
    </MantineProvider>
  </Suspense>
);